module.exports = __webpack_public_path__ + "static/img/sqsp.0ac8687.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bc/sqsp.png
// module id = Rw/9
// module chunks = 0